import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};
const childVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export function HeroSection() {
  return <section className="relative flex min-h-screen w-full items-center justify-center bg-dark px-6 py-20 overflow-hidden" aria-label="Property introduction" data-id="element-93">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-94">
        <img src="https://cdn.magicpatterns.com/uploads/aFXFpju7j751kGy39XvKko/120-124_Dryburgh_Street,_North_Melbourne_RC_v062.jpg" alt="120-124 Dryburgh Street, North Melbourne Drone View" className="w-full h-full object-cover" data-id="element-95" />
        <div className="absolute inset-0 bg-dark/60 mix-blend-multiply" data-id="element-96" />
        <div className="absolute inset-0 bg-gradient-to-t from-dark via-transparent to-dark/40" data-id="element-97" />
      </div>

      {/* Stonebridge logo motif — large, partially visible, right side */}
      <motion.div className="absolute right-[-40px] md:right-[20px] top-1/2 -translate-y-1/2 pointer-events-none z-10" initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 0.08,
      scale: 1
    }} transition={{
      duration: 1.2,
      ease: 'easeOut',
      delay: 0.5
    }} aria-hidden="true" data-id="element-98">
        <img src="https://cdn.magicpatterns.com/uploads/neNaCNBs6EW2ecQoy3yAp9/Stonebridge_logo_master_reversed_1.0.png" alt="" className="w-[400px] md:w-[500px] h-auto" data-id="element-99" />
      </motion.div>

      <motion.div className="relative z-20 flex w-full max-w-4xl flex-col items-center text-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-100">
        <motion.div className="mb-8 inline-block rounded-full bg-accent/10 px-4 py-1.5 backdrop-blur-sm border border-accent/20" variants={childVariants} data-id="element-101">
          <p className="font-heading text-xs font-bold tracking-widest-plus uppercase text-accent" data-id="element-102">
            High Exposure Warehouse
          </p>
        </motion.div>

        <motion.h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-none tracking-tight drop-shadow-lg" variants={childVariants} data-id="element-103">
          120-124
          <span className="block text-accent mt-2" data-id="element-104">Dryburgh St</span>
        </motion.h1>

        <motion.p className="font-heading text-lg md:text-2xl font-bold tracking-widest-plus uppercase text-white mt-6 drop-shadow-md" variants={childVariants} data-id="element-105">
          North Melbourne
        </motion.p>

        <motion.p className="font-body text-sm text-white/70 tracking-wider mt-3" variants={childVariants} data-id="element-106">
          Victoria 3051
        </motion.p>

        <motion.div className="mt-12" variants={childVariants} data-id="element-107">
          <a href="#contact" className="inline-block rounded-full bg-accent px-10 py-4 font-heading text-sm font-bold uppercase tracking-widest-plus text-white transition-all duration-200 hover:bg-accent-dark hover:scale-105 shadow-lg shadow-accent/25" role="button" data-id="element-108">
            Request Details
          </a>
        </motion.div>
      </motion.div>
    </section>;
}